const theme = {
  /**
   * DSquare
   */
  "DSQUARE": {
    primary1Color: '#0288d1',
    primary2Color: '#5dc3ff',
    accent1Color: '#0288d1',
    accent2Color: '#5eb8ff',
    textheaderColor: '#111111',
    textcontentColor: '#333333',
    textactionColor: '#ffffff',
    loadingColor: '#5dc3ff',
    primaryColor: '#0288d1',
    gradient1Color: '#0288d1',
    gradient2Color: '#5dc3ff'
  },
  /**
   * Biz Eyes
   */
  "BIZ-EYES": {
    primary1Color: '#A5B919', // Dark Blue: button, link
    primary2Color: '#A5B919',
    accent1Color: '#0068B3', // button, cta
    // accent2Color: '#A5B919',
    textheaderColor: '#323329',
    textcontentColor: '#323329', // body text
    textactionColor: '#ffffff',
    loadingColor: '#A5B919', // drakgreen
    primaryColor: '#A5B919', // drakgreen
    gradient1Color: '#A5B919',
    gradient2Color: '#A5B919'
  },
  /**
   * Gamma
   */
  "GAMMA": {
    primary1Color: '#FF9800',
    primary2Color: '#FF9800',
    accent1Color: '#FF9800',
    accent2Color: '#FF9800',
    textheaderColor: '#111111',
    textcontentColor: '#331500',
    textactionColor: '#ffffff',
    loadingColor: '#FF9800',
    primaryColor: '#FF9800',
    gradient1Color: '#FFC107',
    gradient2Color: '#FF9800'
  },
  /**
   * Delta
   */
  "DELTA": {
    primary1Color: '#003973',
    primary2Color: '#003973',
    accent1Color: '#E69900',
    accent2Color: '#E69900',
    textheaderColor: '#00254B',
    textcontentColor: '#00254B',
    textactionColor: '#ffffff',
    loadingColor: '#003973',
    primaryColor: '#003973',
    gradient1Color: '#003973',
    gradient2Color: '#003973'
  },
  /**
   * Lang Pho
   */
  LP: {
    primary1Color: '#0288d1',
    primary2Color: '#5dc3ff',
    accent1Color: '#0288d1',
    accent2Color: '#5eb8ff',
    textheaderColor: '#111111',
    textcontentColor: '#333333',
    textactionColor: '#ffffff',
    loadingColor: '#5dc3ff',
    primaryColor: '#0288d1',
    gradient1Color: '#5dc3ff',
    gradient2Color: '#0288d1'
  },
  /**
   * Lune
   */
  LN: {
    primary1Color: '#0288d1',
    primary2Color: '#5dc3ff',
    accent1Color: '#0288d1',
    accent2Color: '#5eb8ff',
    textheaderColor: '#111111',
    textcontentColor: '#333333',
    textactionColor: '#ffffff',
    loadingColor: '#5dc3ff',
    primaryColor: '#0288d1',
    gradient1Color: '#5dc3ff',
    gradient2Color: '#0288d1'
  },
  /**
   * SQC, SEC, HOLDINGS
   */
  "OPTIMUS": {
    primary1Color: '#0288d1',
    primary2Color: '#5dc3ff',
    accent1Color: '#0288d1',
    accent2Color: '#5eb8ff',
    textheaderColor: '#111111',
    textcontentColor: '#333333',
    textactionColor: '#ffffff',
    loadingColor: '#5dc3ff',
    primaryColor: '#0288d1',
    gradient1Color: '#5dc3ff',
    gradient2Color: '#0288d1'
  },
  /**
   * SQC, SEC, HOLDINGS
   */
  "SEC": {
    primary1Color: '#330003',
    primary2Color: '#330003',
    accent1Color: '#8BC34A',
    accent2Color: '#8BC34A',
    textheaderColor: '#111111',
    textcontentColor: '#330003',
    textactionColor: '#ffffff',
    loadingColor: '#FF5252',
    primaryColor: '#FF5252',
    gradient1Color: '#FF7575',
    gradient2Color: '#FF5252'
  },
  /**
   * SQC, SEC, HOLDINGS
   */
  "SQC": {
    primary1Color: '#330003',
    primary2Color: '#330003',
    accent1Color: '#8BC34A',
    accent2Color: '#8BC34A',
    textheaderColor: '#111111',
    textcontentColor: '#330003',
    textactionColor: '#ffffff',
    loadingColor: '#FF5252',
    primaryColor: '#FF5252',
    gradient1Color: '#FF7575',
    gradient2Color: '#FF5252'
  },
  /**
   * SQC, SEC, HOLDINGS
   */
  "SQCC": {
    primary1Color: '#330003',
    primary2Color: '#330003',
    accent1Color: '#8BC34A',
    accent2Color: '#8BC34A',
    textheaderColor: '#111111',
    textcontentColor: '#330003',
    textactionColor: '#ffffff',
    loadingColor: '#FF5252',
    primaryColor: '#FF5252',
    gradient1Color: '#FF7575',
    gradient2Color: '#FF5252'
  },
  /**
   * Skynet
   */
  "GENESYS": {
    primary1Color: '#330003',
    primary2Color: '#330003',
    accent1Color: '#8BC34A',
    accent2Color: '#8BC34A',
    textheaderColor: '#111111',
    textcontentColor: '#330003',
    textactionColor: '#ffffff',
    loadingColor: '#FF5252',
    primaryColor: '#FF5252',
    gradient1Color: '#FF7575',
    gradient2Color: '#FF5252'
  },
  /**
   * PiE
   */
  PE: {
    primary1Color: '#0288d1',
    primary2Color: '#5dc3ff',
    accent1Color: '#0288d1',
    accent2Color: '#5eb8ff',
    textheaderColor: '#111111',
    textcontentColor: '#333333',
    textactionColor: '#ffffff',
    loadingColor: '#5dc3ff',
    primaryColor: '#0288d1',
    gradient1Color: '#5dc3ff',
    gradient2Color: '#0288d1'
  },
  /**
   * Reach
   */
  RE: {
    primary1Color: '#0288d1',
    primary2Color: '#5dc3ff',
    accent1Color: '#0288d1',
    accent2Color: '#5eb8ff',
    textheaderColor: '#111111',
    textcontentColor: '#333333',
    textactionColor: '#ffffff',
    loadingColor: '#5dc3ff',
    primaryColor: '#0288d1',
    gradient1Color: '#5dc3ff',
    gradient2Color: '#0288d1'
  }
}

export default theme



// WEBPACK FOOTER //
// ./src/utils/theme.js